import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SampleService } from '../../core/http/sample.service';
import { SettingsService } from '../../core/http/settings.service';
import { BillingService } from '../../core/http/billing.service';
import { AuthServiceService } from '../../core/http/auth-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SampleCollectModalComponent } from '../../shared/components/sample-collect-modal/sample-collect-modal.component';
import { SampleAcknoledgeModalComponent } from '../../shared/components/sample-acknoledge-modal/sample-acknoledge-modal.component';
import { BarcodeComponent } from '../../shared/components/barcode/barcode.component';
import {
  trigger,
  style,
  animate,
  transition,
  state,
} from '@angular/animations';
import * as _moment from 'moment';
import { RefundComponent } from 'src/app/shared/components/refund/refund.component';
import { DatePipe } from '@angular/common';
const moment = _moment;

@Component({
  selector: 'app-refund-amount',
  templateUrl: './refund-amount.component.html',
  styleUrls: ['./refund-amount.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)' }),
        animate('200ms ease-in', style({ transform: 'translateY(0%)' })),
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateY(-100%)' })),
      ]),
    ]),
  ],
})
export class RefundAmountComponent implements OnInit {
  isLoading = true;
  isSaveLoading = false;
  mode = 'form';
  Errors = null;
  viewAll = true;
  data: any = [];
  listOfService: any = [];
  samples: any = [];
  Success;
  billId;
  message;
  record: any = [];
  templates: any = [];
  receipt;
  payment: any = [];
  recLoad: boolean = false;
  tempLoad: boolean = false;
  reLoad: boolean = false;
  encounters: any = [];
  receiptInfo;
  detail;
  detail2;
  detail3;
  name: string = localStorage.getItem('username');
  ref: any;

  // startdate = localStorage.getItem('startdate');
  // enddate = localStorage.getItem('enddate');
  startdate = '';
  enddate = '';
  sd;
  ed;
  is_verified = -1;
  dept_code = 0;
  sub_dept_code = 0;
  investigation = '';
  nameSearch = '';
  gender = '';
  phone = '';
  is_finalized = -1;
  is_acknowledged = -1;
  is_collected = -1;
  depts: any = [];
  subDepts: any = [];
  investigatonList: any = [];

  Template_Text = '';

  stateForm = new FormGroup({
    sample_id: new FormControl('', Validators.required),
    format_code: new FormControl(''),
    formatstr: new FormControl('', Validators.required),
    result_id: new FormControl(''),
  });

  constructor(
    public router: Router,
    private sample: SampleService,
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public setting: SettingsService,
    public auth: AuthServiceService,
    public bill: BillingService
  ) {}

  ngOnInit(): void {
    this.name = localStorage.getItem('username');
    // this.searchEncounters();
    // this.startdate = moment(new Date()).format('YYYY-MM-DD');
    // this.enddate = moment(new Date()).format('YYYY-MM-DD');
    const currentDate = new Date();
    const twoMonthsAgo = new Date();
    twoMonthsAgo.setMonth(currentDate.getMonth() - 2);
    this.startdate = moment(twoMonthsAgo).format('YYYY-MM-DD');
    this.enddate = moment(currentDate).format('YYYY-MM-DD');
    this.getPayments();
    // this.sample
    // .getPayment('', '', '')
    // .subscribe(
    //   (resSuccess) => {
    //     this.data = resSuccess
    //     this.isLoading = false;
    //     console.log(this.data);

    //   },
    //   (resErr) => {
    //     this.isLoading = false;
    //     this.Errors = resErr;
    //   }
    // )
  }
  // searchEncounters() {
  //   this.isLoading = true;
  //   this.bill
  //     .searchEncounters(
  //       this.startdate,
  //       this.enddate,
  //       this.dept_code,
  //       this.sub_dept_code,
  //       this.investigation,
  //       this.nameSearch,
  //       this.gender,
  //       this.phone,
  //       this.is_verified,
  //       this.is_finalized,
  //       this.is_collected,
  //       this.is_acknowledged
  //     )
  //     .subscribe(
  //       (resSuccess) => {
  //         this.encounters = resSuccess;
  //         this.isLoading = false;
  //         console.log(this.encounters);
  //       },
  //       (resErr) => {
  //         this.isLoading = false;
  //         this.Errors = resErr;
  //       }
  //     );
  // }
  getResult() {
    this.sample.getResults(this.startdate, this.enddate).subscribe(
      (resSuccess:any) => {
        this.data = resSuccess.data;
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }
  startDateChange(event: any) {
    this.startdate = moment(event.target.value).format('YYYY-MM-DD');
  }
  endDateChange(event: any) {
    this.enddate = moment(event.target.value).format('YYYY-MM-DD');
  }

  getPayments() {
    this.isLoading = true;
    this.sample
      .getPayment(this.startdate, this.enddate, this.nameSearch)
      .subscribe(
        (resSuccess) => {
          this.encounters = resSuccess;
          this.isLoading = false;
          console.log(this.encounters);
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
        }
      );
  }

  async view(item) {
    this.reLoad = true;
    console.log(item);
    this.receiptInfo = item;
    console.log(item.bill_id);

    try {
      const billDetail = await this.bill
        .getBillDetail(item.bill_id)
        .toPromise();
      this.reLoad = false;
      this.detail = billDetail;
      this.viewAll = !this.viewAll;
      console.log(this.detail);
      this.listOfService = billDetail.encounterBillItems;
      console.log(billDetail.registration_no);
      if (this.detail.Recd_Payt != 'Yes') {
        const patientInfo = await this.bill
          .getPatients(billDetail.registration_no)
          .toPromise();
        console.log(patientInfo);
        this.cachebillInfo(billDetail, patientInfo);
        this.detail2 = patientInfo[0]?.date_of_birth;
        this.detail3 = this.detail2.slice(0, 10);

        const refDrResponse = await this.bill
          .getRefDrByCode(patientInfo[0].ref_doct_code)
          .toPromise();
        console.log(refDrResponse);
        this.ref = refDrResponse[0];
        console.log('Detail after getDetail:', this.detail); // Debugging statement

        if (this.detail) {
          // this.router.navigateByUrl('/billing');
          console.log('Navigating to billing page');
        } else {
          console.log('Detail not available');
        }
      } else {
        // this._snackBar.open(
        //   `This Bill ${this.detail.bill_no}, is already authorized and cannot be edited.`,
        //   '',
        //   {
        //     duration: 2000,
        //     verticalPosition: 'top',
        //   }
        // );
      }
    } catch (error) {
      this.Errors = error;
      console.log(error);
      this.reLoad = false;
    }
  }

  refund(item) {
    console.log(item);
    const data = {
      bill_id: this.receiptInfo.bill_id,
      receipt_id: this.receiptInfo.receipt_id,
      receipt_no: this.receiptInfo.receipt_no,
      payment_date: this.receiptInfo.receipt_date,
      payment_mode: this.receiptInfo.currency_code,
      amount: item.net_amount,
      bill_no: this.receiptInfo.bill_no,
      sample_ids: [item.service_code],
    };
    this.modal.openModal(RefundComponent, 'modal', data);
    console.log(data);
  }

  refundAll() {
    const serviceCodes = this.listOfService.map(
      (service) => service.service_code
    );
    // console.log(item);
    const data = {
      bill_id: this.receiptInfo.bill_id,
      receipt_id: this.receiptInfo.receipt_id,
      receipt_no: this.receiptInfo.receipt_no,
      payment_date: this.receiptInfo.receipt_date,
      payment_mode: this.receiptInfo.currency_code,
      amount: this.detail.amountPaid - this.detail.refundAmount,
      bill_no: this.receiptInfo.bill_no,
      sample_ids: serviceCodes,
    };
    this.modal.openModal(RefundComponent, 'modal', data);
    console.log(data);
  }

  cachebillInfo(details, patientInfo) {
    this.auth.currentBillItem(details);
    this.auth.currentPatient(patientInfo);
  }

  getTemplate(result_id) {
    this.sample.getPrintResult(result_id).subscribe(
      (resSuccess) => {
        this.tempLoad = false;
        this.templates = resSuccess;
        this.Template_Text = this.templates.data.test_body;
        // console.log(resSuccess)
      },
      (resErr) => {
        this.tempLoad = false;
        this.Errors = resErr;
      }
    );
  }
  addRecord(item) {
    this.mode = 'rec';
    this.tempLoad = true;
    this.record = item;
    this.Errors = '';
    this.getDetail(item.Bill_ID);
    console.log(item);
  }
  // back() {
  //   this.mode = 'form';
  //   this.payment = '';
  //   this.Template_Text = '';
  //   this.receipt = '';
  //   this.detail = {};
  // }
  back() {
    this.viewAll = !this.viewAll;
  }
  // view(item) {
  //   console.log(item);
  //   this.viewAll = !this.viewAll;
  // }
  setReceipt() {
    this.mode = 'rec';
  }
  done() {
    this.mode = 'form';
    this.stateForm.patchValue({
      formatstr: this.Template_Text,
    });
    console.log(this.stateForm.value);
    this._snackBar.open('Template Added Successfully', '', {
      duration: 2000,
      verticalPosition: 'top',
    });
  }
  setTemplate(template) {
    this.Template_Text = template.Template_Text;
  }

  onSubmit(e) {
    // e.preventDefault();
    console.log(this.stateForm.value);
    this.isSaveLoading = true;
    this.Errors = null;
    this.Success = null;
    let is_finalized = true;
    const { sample_id, format_code, formatstr, result_id } =
      this.stateForm.value;
    this.sample.postResultTemplate(sample_id, format_code, formatstr).subscribe(
      (resSuccess) => {
        this.message = resSuccess;
        this.isSaveLoading = false;
        this.stateForm.reset();

        if (this.message.success) {
          this.getResult();
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this.Errors = 'Not successful, please try again';
          console.log('Error Please Try Agian');
          this._snackBar.open('Error Please Try Agian', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      },
      (resErr) => {
        this.isSaveLoading = false;
        this.Errors = resErr;
        console.log(resErr);
      }
    );
    this.sample.postResultFinalize(result_id, is_finalized).subscribe(
      (resSuccess) => {
        this.message = resSuccess;
        this.isSaveLoading = false;
        this.stateForm.reset();

        if (this.message.success) {
          this.getResult();
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this.Errors = 'Not successful, please try again';
          console.log('error');
        }
      },
      (resErr) => {
        this.isSaveLoading = false;
        this.Errors = resErr;
        console.log(resErr);
      }
    );
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          #print-section {
            width: 500px;
          }
          </style>
        </head>
    <body onload="window.print()">${printContents}</body>
      </html>`);
    popupWin.document.close();
  }

  async getDetail(Bill_ID) {
    // console.log(this.detail, 'Detaillllllllllllllll');
    this.reLoad = true;
    console.log(Bill_ID);

    try {
      const billDetail = await this.bill.getBillDetail(Bill_ID).toPromise();
      this.reLoad = false;
      this.detail = billDetail;
      console.log(this.detail);
      console.log(billDetail.registration_no);
      const patientInfo = await this.bill
        .getPatients(billDetail.registration_no)
        .toPromise();
      console.log(patientInfo);
      this.cachebillInfo(billDetail, patientInfo);
      this.detail2 = patientInfo[0]?.date_of_birth;
      this.detail3 = this.detail2.slice(0, 10);

      const refDrResponse = await this.bill
        .getRefDrByCode(patientInfo[0].ref_doct_code)
        .toPromise();
      console.log(refDrResponse);
      this.ref = refDrResponse[0];
      console.log('Detail after getDetail:', this.detail); // Debugging statement
    } catch (error) {
      this.Errors = error;
      console.log(error);
      this.reLoad = false;
    }
  }
}
